import React from 'react';
import Navbar from '../../../components/Navbar';
import Footer from '../../../components/Footer';
import Copyright from '../../../components/Copyright';
import Physiotherapy from './Physiotherapy';

export default function Blog() {
  return (
    <>
        <Navbar />
        <Physiotherapy />
        <Footer />
        <Copyright />
    </>
  )
}